import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('selection-field-radio-group', () => import(/* webpackMode: "lazy" */'./selection-field-radio-group'));
